import React from 'react';
import styled from 'styled-components';
import SVG from 'react-inlinesvg';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@common/components/button';
import { COLOR_BLACK } from '@common/assets/styles/colors';
import svgChevron from '@common/assets/svg/icon-chevron.svg';
import userInterfaceStore from '@store/user-interface';
import { TRootState } from '@store/root-reducer';
import svgIconSpinner from '@common/assets/svg/icon-loading_spinner.svg';
import { useIntl } from 'react-intl';

export const StepButtonsSC = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;

  .btn-wrp {
    width: 172px;
  }
  
  .btn-wrp.prev {
    > button {
      background-color: transparent;
      color: ${COLOR_BLACK};
      text-align: left;
      padding-left: 0;

      svg {
        width: 6px;
        height: 12px;
        margin-bottom: 3px;
        margin-right: 16px;
        transform: rotate(180deg);

        path {
          stroke: ${COLOR_BLACK};
        }
      }
    }
  }
`;

type TStepButtonsProps = {
  renderNextBtn?: boolean;
  renderPrevBtn?: boolean;
  handlePrevClick?: () => void;
  handleNextClick?: () => void;
  nextBtnLabel?: string;
  nextBtnLoading?: boolean;
};

const StepButtons: React.FC<TStepButtonsProps> = ({
  renderNextBtn = false,
  renderPrevBtn = true,
  handlePrevClick,
  handleNextClick,
  nextBtnLabel,
  nextBtnLoading,
}: TStepButtonsProps) => {
  const nextBtnDisabled = useSelector(
    (store: TRootState) => store.userInterface.nextStepDisabled,
  );

  const dispatch = useDispatch();
  const { formatMessage } = useIntl();

  return (
    <StepButtonsSC>
      {renderPrevBtn ? (
        <div className="btn-wrp prev">
          <Button
            size="large"
            onClick={
              handlePrevClick
                ? handlePrevClick
                : () => dispatch(userInterfaceStore.moveToPrevStep())
            }
          >
            <SVG src={svgChevron} />
            {formatMessage({ id: 'buttons.back' })}
          </Button>
        </div>
      ) : null}
      {renderNextBtn ? (
        <div className="btn-wrp">
          <Button
            disabled={nextBtnDisabled}
            size="large"
            onClick={
              handleNextClick
                ? handleNextClick
                : () => dispatch(userInterfaceStore.moveToNextStep())
            }
            isBlock
          >
            {nextBtnLabel
              ? nextBtnLabel
              : formatMessage({ id: 'buttons.continue' })}
            {nextBtnLoading ? <SVG src={svgIconSpinner} /> : null}
          </Button>
        </div>
      ) : null}
    </StepButtonsSC>
  );
};

export default StepButtons;
